<template>
  <div class="settings">
    <div class="colorSettings">
      <h2>Primary color</h2>
      <div class="colors">
        <div @click="changeColor('crimsonRed')" class="color crimsonRed"></div>
        <div @click="changeColor('violet')" class="color violet"></div>
        <div @click="changeColor('deepPink')" class="color deepPink"></div>
      </div>
    </div>
    <div class="backgroundSettings">
      <h2>Background</h2>
      <div class="backgrounds">
        <div @click="changeColor('blackBg')" class="background blackBg"></div>
        <div @click="changeColor('debianBg')" class="background debianBg"></div>
        <div @click="changeColor('whiteBg')" class="background whiteBg"></div>
        <div @click="changeColor('roséBg')" class="background roséBg"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      root: null,
    };
  },
  mounted: function () {
    this.root = document.documentElement;
  },
  methods: {
    changeColor(color) {
      switch (color) {
        case "crimsonRed":
          this.root.style.setProperty("--primary", "#aa0028");
          this.root.style.setProperty("--primary-light", "#c01739");
          this.root.style.setProperty("--primary-dark", "#fd003b80");
          this.root.style.setProperty("--primary-hover", "#f0496a");
          this.root.style.setProperty("--primary-focus", "#da3959");
          break;

        case "violet":
          this.root.style.setProperty("--primary", "#6e12a7");
          this.root.style.setProperty("--primary-light", "#8526c0");
          this.root.style.setProperty("--primary-dark", "#9d00ff80");
          this.root.style.setProperty("--primary-hover", "#ad4beb");
          this.root.style.setProperty("--primary-focus", "#942dd4");
          break;

        case "deepPink":
          this.root.style.setProperty("--primary", "#cb006d");
          this.root.style.setProperty("--primary-light", "#fc359f");
          this.root.style.setProperty("--primary-dark", "#ff2f9e80");
          this.root.style.setProperty("--primary-hover", "#ff80c3");
          this.root.style.setProperty("--primary-focus", "#ff3ea5");
          break;

        case "blackBg":
          this.root.style.setProperty("--background-color", "#111111");
          this.root.style.setProperty("--background-color-light", "#2b2b2b");
          this.root.style.setProperty("--font-color", "#eeeeee");
          break;

        case "debianBg":
          this.root.style.setProperty(
            "--background-color",
            "url(" +
              require("@/assets/coolBackground.png") +
              ") center / cover no-repeat var(--primary)"
          );
          this.root.style.setProperty("--background-color-light", "#2b2b2b");
          this.root.style.setProperty("--font-color", "#eeeeee");
          break;

        case "whiteBg":
          this.root.style.setProperty(
            "--background-color",
            "linear-gradient(to top, #ada996, #f2f2f2, #dbdbdb, #eaeaea)"
          );
          this.root.style.setProperty("--background-color-light", "#dddddd");
          this.root.style.setProperty("--font-color", "#222222");
          break;

        case "roséBg":
          this.root.style.setProperty(
            "--background-color",
            "linear-gradient(to left bottom, #f7a3ff, #d08ad7, #ab71b0, #865a8b, #644367)"
          );
          this.root.style.setProperty("--background-color-light", "#3a2b3cbf");
          this.root.style.setProperty("--font-color", "#eeeeee");
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style>
h2 {
  margin: 10px 0;
}
.settings {
  display: flex;
  flex-wrap: wrap;
  margin-left: 10px;
}
.colorSettings {
  padding-bottom: 10px;
}
.backgroundSettings {
  border-top: 1px solid var(--primary-hover);
}
.colors {
  display: flex;
  justify-content: left;
  flex-flow: row wrap;
}
.backgrounds {
  display: flex;
  justify-content: left;
  flex-flow: row wrap;
}
.background {
  width: 60px;
  height: 40px;
  cursor: pointer;
}
.color {
  width: 60px;
  height: 40px;
  cursor: pointer;
}
.crimsonRed {
  background-color: #aa0028;
}
.violet {
  background-color: #6e12a7;
}
.deepPink {
  background-color: #ff1493;
}
.blackBg {
  background-color: #111111;
}
.debianBg {
  background: url("https://w.wallha.com/ws/7/QP4MARSC.png") center / cover
    no-repeat;
}
.whiteBg {
  background: linear-gradient(to top, #ada996, #f2f2f2, #dbdbdb, #eaeaea);
}
.roséBg {
  background: linear-gradient(
    to left bottom,
    #f7a3ff,
    #d08ad7,
    #ab71b0,
    #865a8b,
    #644367
  );
}
</style>